import React from "react";

import "./index.css";

interface Props {
    title: string;
    value: string;
}

export default function DataItem({ title, value }: Props) {
    return (
        <div className="dataPanel">
            <p className="dataTitle">{title}</p>
            <p className="dataValue">{value}</p>
        </div>
    );
}
